var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('card-list',{attrs:{"title":"Item List","dataUrl":"/api/v1/product","dataSize":"10","dataHeaders":_vm.tHeaders,"deleteEndpoint":"/api/v1/product","editRoute":"/master/item/add"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }